import axios from "axios";

export async function createNewUser(userData){
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth/register`, userData);
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
    }
}

export async function loginUser(userData){
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth/login`, userData);
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
    }
}

export async function googleLoginUser(access_token){
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth/google-login`, {access_token});
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
    }
}

export async function validateTokenInitially() {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/auth/verification`, {
        withCredentials: true
    });
    return response.data;
}

export async function signoutUser(){
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/auth/logout`,{
        withCredentials: true
    });
   return response.data;
}